import { render } from "./EstadoCuenta.vue?vue&type=template&id=5564311f"
import script from "./EstadoCuenta.vue?vue&type=script&lang=js"
export * from "./EstadoCuenta.vue?vue&type=script&lang=js"

import "./EstadoCuenta.vue?vue&type=style&index=0&id=5564311f&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__